module.exports = __webpack_public_path__ + "static/media/ELIZANGELA_CAMISA.40c4950d.png";